<template>
  <v-container>
    <v-timeline dense>
      <v-timeline-item v-for="(item, i) in data" :key="i">
        <template>
          <span :class="`headline font-weight-bold ${'#111827'}--text`">{{
            formatDate(item.date)
          }}</span>
        </template>
        <div class="py-4">
          <h2 :class="`headline font-weight-light mb-4 pink--text`">
            {{ item.GROUP_NAME }}
          </h2>
          <div>
            {{ item.PCP_NAME }}
          </div>
        </div>
      </v-timeline-item>
    </v-timeline>
  </v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'History',
  props: ['patient', 'insurance', 'recordLimit'],
  data: () => ({
    data: [],
  }),
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      axios.get(`/api/patient/history/${this.insurance}/${this.patient}`).then((response) => {
        this.data = response.data;
      });
    },
    formatDate(date) {
      const year = moment(date).year();
      if (year === 9999) {
        return 'Current Provider';
      }
      return moment(date).format('YYYY-MM');
    },
  },
  computed: {
    moment() {
      return moment;
    },
  },
};
</script>
<style scoped></style>
